import React, { useState, useEffect } from 'react';
import imageValidator from './image-validator';
import IsFetchingInline from '../../../common/IsFetchingInline.jsx';
import PropTypes from 'prop-types';

function ImageEditor(props) {
  let [uploadError, setUploadError] = useState(null);
  let [image, setImage] = useState(props.image);

  useEffect(() => { setImage(props.image) }, [props.image]);

  const handleOnChange = (event) => {
    const file = event.target.files[0];
    const error = imageValidator(file);
    if (!error){
      setUploadError(undefined);

      let formData = new FormData();
      formData.set(props.fieldName, file);
      props.onChange(formData);
    } else {
      setUploadError(error);
    }
  };

  return <div className="mb-3 mb-md-0">
    <div className="text-center">
      { (props.isFetching || image === undefined) && <div className={'cabinet-' + props.fieldName + '-placeholder mr-3'}>
        <IsFetchingInline isFetching={ props.isFetching }/>
      </div> }
      { !props.isFetching && <img src={ image ? image : props.emptyPlaceholder } alt=""
                                  className={'media-img mr-3' + (props.scaleImage ? ' image-scale': '') } /> }
    </div>
    <div className="mt-3 text-left">
      <div className={ uploadError ? 'was-validate' : '' }>
        <input type="file"
               className={ 'd-none' + (uploadError ? ' is-invalid' : '') }
               id={'userImage' + (props.id ? props.id : '')}
               onChange={ handleOnChange }
        />
        <label htmlFor={'userImage' + (props.id ? props.id : '')}
               className="btn btn-sm btn-link p-0 m-0"
               title={ props.image ? gettext('Заменить') : gettext('Добавить')  + ' ' + props.entryName }>
          <i className="icon icon-floppy"></i>
          { props.image ? gettext('Заменить') : gettext('Добавить')  + ' ' + props.entryName }
        </label>
        { uploadError && <span className="invalid-feedback">{ uploadError }</span> }
      </div>
    </div>
    { (props.image && props.onDelete) &&
    <div className="text-left">
      <button className="btn btn-sm btn-link p-0 m-0" onClick={ props.onDelete }
              title={ gettext('Удалить')  + ' ' + props.entryName}>
        <i className="icon icon-trash-empty"></i>
        { gettext('Удалить') + ' ' + props.entryName }
      </button>
    </div> }
  </div>
}

ImageEditor.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  image: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  emptyPlaceholder: PropTypes.string.isRequired,
  entryName: PropTypes.string.isRequired,
};

export default ImageEditor;
